const isBlank = (value) => value === undefined || value === null || value === '';

export function parseAccessGroupRangeInput(value) {
  if (value === '' || value === '-') return value;
  if (typeof value === 'number') return value;

  return Number(String(value).replace(/\./g, '').replace(',', '.'));
}

export function buildAccessGroupRangePayload(accessGroupData, clearEmptyRange = false) {
  const minValue = accessGroupData?.min_grievance_percent;
  const maxValue = accessGroupData?.max_grievance_percent;
  const minIsBlank = isBlank(minValue);
  const maxIsBlank = isBlank(maxValue);

  if (minIsBlank && maxIsBlank) {
    return {
      payload: clearEmptyRange ? { min_grievance_percent: null, max_grievance_percent: null } : {},
    };
  }

  if (minIsBlank || maxIsBlank) {
    return { error: 'Informe os limites mínimo e máximo do slider, ou deixe ambos em branco.' };
  }

  const min = Number(minValue);
  const max = Number(maxValue);

  if (!Number.isFinite(min) || !Number.isFinite(max)) {
    return { error: 'Os limites mínimo e máximo do slider devem ser números válidos.' };
  }

  if (min > max) {
    return { error: 'O limite mínimo do slider não pode ser maior que o máximo.' };
  }

  return { payload: { min_grievance_percent: min, max_grievance_percent: max } };
}
